import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import DigitizeImg from "../../../images/location_new/fold5/img06.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Accelerate Your Business Growth with A Top Flutter Application
              Development Company
            </h2>
            <p>
              With our Flutter app development services, businesses can stay
              ahead of the competition in app development by using Flutter's
              well-supported ecosystem and quickly adapt to changing user needs.
              Hire Flutter app developers to advance your app development using
              a flexible Google framework, saving time and money with a single
              codebase and offering consistent user experiences across
              platforms.
            </p>
            <p>
              We’re serving a wide range of industries as an award-winning
              Flutter development agency in UK. You'll see the benefits of
              cutting-edge mobile apps and receive the highest return on your
              investment.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="mobile-app-development-company-uk"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
